import styled from 'styled-components';
import { Icon, IconType } from '../icon';
import { useChipContext } from './chip.context';

interface ChipIconProps {
	/**
	 * The icon to use.
	 */
	type: IconType;
}

const StyledChipIcon = styled(Icon)`
	color: var(--iconColor, currentColor);
`;

/* ########################################################################## */
/* ############################### PUBLIC API ############################### */
/* ########################################################################## */

/**
 * A decorative icon placed before the label of a `Chip`. It automatically
 * adapts its size to the `size` of the `Chip` and inherits the color from its
 * `type`.
 *
 * Don't combine it with `ChipColorSwatch`, a chip should only have one leading
 * element.
 */
export function ChipIcon({ type }: ChipIconProps) {
	const { size } = useChipContext();

	return <StyledChipIcon type={type} size={size === 'small' ? 'xSmall' : 'small'} />;
}

export type { ChipIconProps };
